import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import Dict from 'dict-lib';
import {Navbar, NavbarBrand, Glyphicon, Button} from 'react-bootstrap';
import {AdministrationUtilities} from "../../administration/AdministrationHelper";

export class SCFooter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            footerVisible: true
        };
    }

    _toggleFooter() {
        this.setState((prevState) => ({
            footerVisible: !prevState.footerVisible
        }), () => {
            // Keep this aligned with the CSS transition duration.
            window.setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 280);
        });
    }

    componentDidMount() {

        const useCustomFooter = AdministrationUtilities.useCustomFooter();
        if(useCustomFooter) {
            this._loadCustomFooter();
        }
    }

    _loadCustomFooter() {
        const installationInd = AdministrationUtilities.getInstallationId();
        const Header = React.lazy(() => import('../../_custom-layout/' + installationInd + '/Footer'));

        function LoadLazyComponent() {
            return (
                <div>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Header/>
                    </Suspense>
                </div>
            );
        }

        var LazyComponent = LoadLazyComponent();
        ReactDOM.render(LazyComponent, document.getElementById('footer-navbrand'));
    }

    render() {

        var text = Dict.getGlobalProperty('FOOTER');

        const customFooter = Dict.getGlobalProperty('CUSTOM_FOOTER');
        let embedObj;

        const toggleButton = AdministrationUtilities.isDictOrGlossary() ? (
            <div style={{position: 'fixed', bottom: '1px', left: '22px', zIndex: 9999}}>
                <Button
                    id="bt-hide-show-footer"
                    onClick={() => this._toggleFooter()}
                    bsStyle="default"
                    style={{
                        padding: '2px 7px 0 7px',
                        height: '24px',
                        lineHeight: '1',
                        borderRadius: '0 0 3px 3px',
                        borderTopLeftRadius: '0',
                        borderTopRightRadius: '0',
                        borderBottomLeftRadius: '3px',
                        borderBottomRightRadius: '3px',
                        borderTop: '1',
                        boxShadow: '0 1px 4px 0 rgba(10, 10, 10, .3)'
                    }}
                >
                    <Glyphicon glyph={this.state.footerVisible ? 'triangle-bottom' : 'triangle-top'} style={{fontSize: '12px'}}/>
                </Button>
            </div>
        ) : '';

        const footerTransitionStyle = {
            overflow: 'hidden',
            maxHeight: this.state.footerVisible ? '220px' : '0px',
            opacity: this.state.footerVisible ? 1 : 0,
            transition: 'max-height 280ms ease, opacity 280ms ease'
        };

        const storedArea = AdministrationUtilities.retrieveStoredArea('footer');
        if (typeof customFooter !== 'undefined' && customFooter === 'true' && storedArea) {
            embedObj =
                <embed style={{
                    /*width: '100%',*/
                    /*height: '90px',*/
                    /*padding: '0',*/
                    /*margin: '0',*/
                    backgroundColor: 'white'
                    /*objectFit: 'fill'*/
                }}
                       src={'service/footer/' + storedArea}/>;

            return <>
                {toggleButton}
                <div style={{
                    position: 'fixed',
                    bottom: '5px',
                    /*display: 'flex',*/
                    marginLeft: '0',
                    paddingLeft: '0',
                    height: '100px',
                    ...footerTransitionStyle
                }}>
                    <div>{embedObj}</div>
                </div>
            </>
        } else {
            embedObj = text;
            return (
                <>
                    {toggleButton}
                    <div id="sc-footer" className="" style={footerTransitionStyle}>
                        <Navbar>
                            <div style={{width: '100%'}} fluid>
                                <NavbarBrand id={'footer-navbrand'}>{embedObj}</NavbarBrand>
                            </div>
                        </Navbar>
                    </div>
                </>
            )
        }
    }
}